var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightBrace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75086 14C7.65578 13.2289 8.34307 12.2507 8.81271 11.0654C9.2709 9.86847 9.5 8.51624 9.5 7.00863C9.5 5.48952 9.2709 4.13728 8.81271 2.95191C8.34307 1.76654 7.65578 0.782573 6.75086 0H4.5C5.30183 0.678997 5.93184 1.64571 6.39003 2.90012C6.84822 4.15454 7.07732 5.52404 7.07732 7.00863C7.07732 8.49322 6.84822 9.86272 6.39003 11.1171C5.92039 12.3601 5.29038 13.321 4.5 14H6.75086Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBrace);
export default __webpack_public_path__ + "static/media/rightBrace.780fa5bc6af090edb9f8407215d0aa83.svg";
export { ForwardRef as ReactComponent };